import React from "react";

const SubmitContent = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        D.
        <span className="text-[#01A7D1] "> USE OF SUBMITTED CONTENT</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          1. Consent for Use of Sensitive Personal Information
        </h1>
        You hereby grant consent to Yostel to collect, store, use or dispose of
        any sensitive personal information requested or submitted by you at your
        sole discretion through our platform, so collected for the intended
        usage as per the terms and conditions agreed herein. Yostel shall not be
        responsible for the authenticity of such personal information or
        sensitive personal data or information submitted by you.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          2. Confidentiality
        </h1>
        The Platform may now or in the future permit the submission of videos or
        other communications submitted by you and other users, including without
        limitation, your Profile, any Feedback, and all Submitted Content, and
        the hosting, sharing, and/or publishing of such Submitted Content. You
        understand that whether or not such Submitted Content is published,
        Yostel does not guarantee any confidentiality with respect to any
        Submitted Content.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You agree that any Submitted Content provided by you for which you
        authorize to be searchable by Registered Users who have access to the
        Platform is provided on a non-proprietary and non-confidential basis.
        You agree that Yostel shall be free to use or disseminate such freely
        searchable Submitted Content on an unrestricted basis for the purpose of
        providing the Services.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Yostel may also disclose user information including personal information
        if Yostel reasonably believes that disclosure (i) is necessary in order
        to comply with a legal process (such as a court order, search warrant,
        etc.) or other legal requirement of any governmental authority, (ii)
        would potentially mitigate Yostel’s liability in an actual or potential
        lawsuit, (iii) is otherwise necessary or appropriate to protect our
        rights or property, or the rights or property of any person or entity,
        (iv) to enforce this Agreement (including, but not limited to ensuring
        payment of fees by users), or (v) as may be required or necessary to
        deter illegal behaviour (including, but not limited to, fraud).
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          3. Consent for Communication
        </h1>
        By registering on this website or by submitting your details, you
        disclaim your National Do Not Call Registry (NDNC) and authorize Yostel
        and its representatives and partners or third parties to contact you
        through call, SMS, E-Mail, WhatsApp or through any other mode of
        communication for commercial/transactional/promotional or for any other
        purposes. If you wish not to be contacted through the foregoing modes
        for the said purposes, you shall not submit your details herein.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          4. Your Representations and Warranties
        </h1>
        You shall be solely responsible for your own Submitted Content and the
        consequences of posting or publishing it. In connection with Submitted
        Content, you affirm, represent, and/or warrant that: (a) you own or have
        the necessary licenses, rights, consents, to use and authorize Yostel to
        use all patent, trademark, trade secret, copyright or other proprietary
        rights in and to any and all Submitted Content to enable inclusion and
        use of the Submitted Content in the manner contemplated by the Platform
        and these Terms of Use; and (b) you have the written consent, release,
        and/or permission of each and every identifiable individual person in
        the Submitted Content to use the name or likeness of each and every such
        identifiable individual person to enable inclusion and use of the
        Submitted Content in the manner contemplated by the Platform and these
        Terms of Use. You agree to pay for all royalties, fees, and any other
        monies owing any person by reason of any Submitted Content posted by you
        to or through the Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          5. Your Ownership Rights and License to Yostel
        </h1>
        You retain all of your ownership rights in your Submitted Content.
        However, by submitting the Submitted Content to Yostel for posting on
        the Platform, you hereby grant, and you represent and warrant that you
        have the right to grant, to Yostel a perpetual, worldwide,
        non-exclusive, royalty-free, sublicense able and transferable license to
        link to, use, reproduce, distribute, reformat, translate, prepare
        derivative works of, display, and perform the Submitted Content in
        connection with the Platform and Yostel's (and its successor's) business
        operations, including without limitation, for the promotion and
        redistribution of any part or all of the Platform, and any derivative
        works thereof, in any media formats and through any media channels. You
        also hereby grant each user of the Platform a non-exclusive license to
        access your Submitted Content through the Platform, and to use,
        reproduce, distribute, prepare derivative works of, display and perform
        such Submitted Content as permitted through the functionality of the
        Platform and under these Terms of Use. The foregoing license granted by
        you terminates once you remove or delete the Submitted Content from the
        Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          4. Your Representations and Warranties
        </h1>
        You shall be solely responsible for your own Submitted Content and the
        consequences of posting or publishing it. In connection with Submitted
        Content, you affirm, represent, and/or warrant that: (a) you own or have
        the necessary licenses, rights, consents, to use and authorize Yostel to
        use all patent, trademark, trade secret, copyright or other proprietary
        rights in and to any and all Submitted Content to enable inclusion and
        use of the Submitted Content in the manner contemplated by the Platform
        and these Terms of Use; and (b) you have the written consent, release,
        and/or permission of each and every identifiable individual person in
        the Submitted Content to use the name or likeness of each and every such
        identifiable individual person to enable inclusion and use of the
        Submitted Content in the manner contemplated by the Platform and these
        Terms of Use. You agree to pay for all royalties, fees, and any other
        monies owing any person by reason of any Submitted Content posted by you
        to or through the Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          5. Your Ownership Rights and License to Yostel
        </h1>
        You retain all of your ownership rights in your Submitted Content.
        However, by submitting the Submitted Content to Yostel for posting on
        the Platform, you hereby grant, and you represent and warrant that you
        have the right to grant, to Yostel a perpetual, worldwide,
        non-exclusive, royalty-free, sublicense able and transferable license to
        link to, use, reproduce, distribute, reformat, translate, prepare
        derivative works of, display, and perform the Submitted Content in
        connection with the Platform and Yostel's (and its successor's) business
        operations, including without limitation, for the promotion and
        redistribution of any part or all of the Platform, and any derivative
        works thereof, in any media formats and through any media channels. You
        also hereby grant each user of the Platform a non-exclusive license to
        access your Submitted Content through the Platform, and to use,
        reproduce, distribute, prepare derivative works of, display and perform
        such Submitted Content as permitted through the functionality of the
        Platform and under these Terms of Use. The foregoing license granted by
        you terminates once you remove or delete the Submitted Content from the
        Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You acknowledge and understand that the technical processing and
        transmission of the Platform, including your Submitted Content, may
        involve (a) transmissions over various networks; and (b) changes to
        conform and adapt to technical requirements of connecting networks or
        devices.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You may remove your Submitted Content from the Platform at any time. If
        you choose to remove your Submitted Content, the license granted above
        will automatically expire.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          6. Yostel's Disclaimers and Right to Remove
        </h1>
        Yostel does not endorse any Submitted Content, or any opinion,
        recommendation, or advice expressed therein, and Yostel expressly
        disclaims any and all liability in connection with all Submitted
        Content. Yostel does not permit copyright infringing activities and
        infringement of intellectual property rights on the Platform, and Yostel
        will remove any Data (as defined below) or Submitted Content if properly
        notified, pursuant to the "take down" notification procedure described
        below, that such Posting or Submitted Content infringes on another's
        intellectual property rights. Yostel reserves the right to remove any
        Data or Submitted Content without prior notice. Yostel will also
        terminate a user's access to the Platform, if he or she is determined to
        be a repeat infringer. A repeat infringer is a Platform user who has
        been notified of infringing activity more than twice and/ or has had
        Submitted Content removed from the Platform more than twice. Yostel also
        reserves the right, in its sole and absolute discretion, to decide
        whether any Data or Submitted Content is appropriate and complies with
        these Terms of Use for all violations, in addition to copyright
        infringement and violations of intellectual property law, including, but
        not limited to, pornography, obscene or defamatory material, or
        excessive length. Yostel may remove such Submitted Content and/or
        terminate a user's access for uploading such material in violation of
        these Terms of Use at any time, without prior notice and in its sole
        discretion.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You acknowledge and understand that when using the Platform, you will be
        exposed to Submitted Content from a variety of sources, and that Yostel
        is not responsible for the accuracy, usefulness, safety, or intellectual
        property rights of or relating to such Submitted Content. You further
        acknowledge and understand that you may be exposed to Submitted Content
        that is inaccurate, offensive, indecent, or objectionable, and you agree
        to waive, and hereby do waive, any legal or equitable rights or remedies
        you have or may have against Yostel with respect thereto, and agree to
        indemnify and hold Yostel, its owners, members, managers, operators,
        directors, officers, agents, affiliates, and/or licensors, harmless to
        the fullest extent allowed by law regarding all matters related to your
        use of the Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You are solely responsible for the photos, profiles and other content,
        including, without limitation, Submitted Content that you publish or
        display on or through the Platform, or transmit to other Platform users.
        You understand and agree that Yostel may, in its sole discretion and
        without incurring any liability, review and delete or remove any
        Submitted Content that violates this Agreement or which might be
        offensive, illegal, or that might violate the rights, harm, or threaten
        the safety of Platform users or others.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          7. Suggestions
        </h1>
        If you send or transmit any communications, comments, questions,
        suggestions, or related materials to Yostel, whether by letter, email,
        telephone, or otherwise (collectively, "Suggestions"), suggesting or
        recommending changes to the Platform, including, without limitation, new
        features or functionality relating thereto, all such Suggestions are,
        and will be treated as, non-confidential and non-proprietary. You hereby
        assign all right, title, and interest in, and Yostel is free to use,
        without any attribution or compensation to you, any ideas, know-how,
        concepts, techniques, or other intellectual property and proprietary
        rights contained in the Suggestions, whether or not patentable, for any
        purpose whatsoever, including but not limited to, developing,
        manufacturing, having manufactured, licensing, marketing, and selling,
        directly or indirectly, products and services using such Suggestions.
        You understand and agree that Yostel is not obligated to use, display,
        reproduce, or distribute any such ideas, know-how, concepts, or
        techniques contained in the Suggestions, and you have no right to compel
        such use, display, reproduction, or distribution or seek recognition if
        the Suggestions are in fact implemented.
      </p>
    </div>
  );
};

export default SubmitContent;
